export default "__VITE_ASSET__ClwrsNVP__"